export default function ChatHeader({
	selectedChat,
	chatSearch,
	setChatSearch,
	matchIndexes,
	currentMatch,
	setCurrentMatch,
}) {
	return (
		<div className="h-14 px-4 flex items-center justify-between bg-white border-b">
			{selectedChat ? (
				<>
					<div className="font-semibold">{selectedChat.displayName}</div>

					<div className="flex items-center gap-2">
						<input
							value={chatSearch}
							onChange={(e) => setChatSearch(e.target.value)}
							placeholder="Search messages"
							className="w-52 px-3 py-1.5 bg-gray-100 rounded-full text-sm"
						/>

						{matchIndexes.length > 0 && (
							<>
								<button
									onClick={() =>
										setCurrentMatch((p) =>
											p > 0 ? p - 1 : matchIndexes.length - 1,
										)
									}
									className="px-2 py-1 bg-gray-200 rounded"
								>
									↑
								</button>

								<button
									onClick={() =>
										setCurrentMatch((p) =>
											p < matchIndexes.length - 1 ? p + 1 : 0,
										)
									}
									className="px-2 py-1 bg-gray-200 rounded"
								>
									↓
								</button>

								<span className="text-xs text-gray-500">
									{currentMatch + 1}/{matchIndexes.length}
								</span>
							</>
						)}
					</div>
				</>
			) : (
				<div className="text-gray-400">Select a chat</div>
			)}
		</div>
	);
}
